export const generateCompaniesCSV = (companiesWithPrimaryContacts) => {
  const headers = [
    'ID',
    'Company Name',
    'Type',
    'Created (mm/dd/yyyy)',
    'State',
    'Web Address',
    'Phone',
    'Primary Contact',
    'Primary Contact Email',
    'Primary Contact Phone',
  ];

  const rows = companiesWithPrimaryContacts.map((company) => [
    company.companyID ?? '',
    company.companyName ?? '',
    company.type ?? '',
    company.dateCreated ?? '',
    company.companyState ?? '',
    company.webAddress ?? '',
    company.phoneNumber ?? '',
    company.primaryContactName ?? '',
    company.primaryContactEmail ?? '',
    company.primaryContactPhone ?? '',
  ]);

  const csvContent = [headers, ...rows]
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const now = new Date();
  const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
  link.setAttribute('download', `companies_${timestamp}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
